import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes, ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { RecuperarPasswordComponent } from './logins/pass/recuperar-password.component';
import { MedicoComponent } from './medicos/medico/medico.component';
import { MedicoCasosclinicosComponent } from './medicos/medico-casosclinicos/medico-casosclinicos.component';
import { SigninComponent } from './logins/signin/signin.component';
import { SignupComponent } from './logins/signup/signup.component';
import { EnfermeraComponent } from './enfermeras/enfermera/enfermera.component';
import { SupervisorComponent } from './supervisores/supervisor/supervisor.component';
import { AdministradorComponent } from './administradores/administrador/administrador.component';
import { AdministradorCasosclinicosComponent } from './administradores/administrador-casosclinicos/administrador-casosclinicos.component';
import { AdministradorCasoclinicoUpdateComponent } from './administradores/administrador-casoclinico-update/administrador-casoclinico-update.component';
import { AdministradorEnfermerasComponent } from './administradores/administrador-enfermeras/administrador-enfermeras.component';
import { AdministradorProductosComponent } from './administradores/administrador-productos/administrador-productos.component';
import { AdministradorProductoComponent } from './administradores/administrador-producto/administrador-producto.component';
import { AdministradorMedicosComponent } from './administradores/administrador-medicos/administrador-medicos.component';
import { AdministradorSupervisoresComponent } from './administradores/administrador-supervisores/administrador-supervisores.component';
import { MedicoProductosComponent } from './medicos/medico-productos/medico-productos.component';
import { AdministradorHospitalesComponent } from './administradores/administrador-hospitales/administrador-hospitales.component';
import { AdministradorHospitalNuevoComponent } from './administradores/administrador-hospital-nuevo/administrador-hospital-nuevo.component';
import { AdministradorInstitucionesComponent } from './administradores/administrador-instituciones/administrador-instituciones.component';
import { AdministradorInstitucionNuevoComponent } from './administradores/administrador-institucion-nuevo/administrador-institucion-nuevo.component';
import { AdministradorCatalogoComponent } from './administradores/administrador-catalogo/administrador-catalogo.component';
import { AdministradorUsuariosComponent } from './administradores/administrador-usuarios/administrador-usuarios.component';
import { MedicoRegistrarNuevoComponent } from './medicos/medico-registrar-nuevo/medico-registrar-nuevo.component';
import { EnfermeraRegistrarNuevoComponent } from './enfermeras/enfermera-registrar-nuevo/enfermera-registrar-nuevo.component';
import { SupervisorRegistrarNuevoComponent } from './supervisores/supervisor-registrar-nuevo/supervisor-registrar-nuevo.component';
import { AdministradorCasoclinicoComponent } from './administradores/administrador-casoclinico/administrador-casoclinico.component';
import { AdministradorMedicoComponent } from './administradores/administrador-medico/administrador-medico.component';
import { AdministradorInformacionInicialComponent } from './administradores/administrador-informacion-inicial/administrador-informacion-inicial.component';
import { AdministradorEnfermeraComponent } from './administradores/administrador-enfermera/administrador-enfermera.component';
import { AdministradorSupervisorComponent } from './administradores/administrador-supervisor/administrador-supervisor.component';
import { MedicoCasoclinicoComponent } from './medicos/medico-casoclinico/medico-casoclinico.component';
import { AuthService } from 'src/app/services/auth.service';
import { MedicoSaldoComponent } from './medicos/medico-saldo/medico-saldo.component';
import { MedicoCanjesComponent } from './medicos/medico-canjes/medico-canjes.component';
import { MedicoCanjeComponent } from './medicos/medico-canje/medico-canje.component';
import { EnfermeraCasosclinicosComponent } from './enfermeras/enfermera-casosclinicos/enfermera-casosclinicos.component';
import { EnfermeraProductosComponent } from './enfermeras/enfermera-productos/enfermera-productos.component';
import { EnfermeraSaldoComponent } from './enfermeras/enfermera-saldo/enfermera-saldo.component';
import { EnfermeraCanjesComponent } from './enfermeras/enfermera-canjes/enfermera-canjes.component';
import { EnfermeraCanjeComponent } from './enfermeras/enfermera-canje/enfermera-canje.component';
import { SupervisorCasosclinicosComponent } from './supervisores/supervisor-casosclinicos/supervisor-casosclinicos.component';
import { SupervisorEnfermerasComponent } from './supervisores/supervisor-enfermeras/supervisor-enfermeras.component';
import { SupervisorPendientesAsignarComponent } from './supervisores/supervisor-pendientes-asignar/supervisor-pendientes-asignar.component';
import { RedimirEnfermeraAtenderComponent } from '../components/redimir-enfermera-atender/redimir-enfermera-atender.component';
import { RedimirMedicoAtenderComponent } from '../components/redimir-medico-atender/redimir-medico-atender.component';
import { RedimirMedicoVistaComponent } from '../components/redimir-medico-vista/redimir-medico-vista.component';
import { RedimirEnfermeraVistaComponent } from '../components/redimir-enfermera-vista/redimir-enfermera-vista.component';
import { AdministradorProductosUploadBatchComponent } from './administradores/administrador-productos-upload-batch/administrador-productos-upload-batch.component';
import { SupervisorEnfermeraComponent } from './supervisores/supervisor-enfermera/supervisor-enfermera.component';
import { DiagnosticosComponent } from './catalogos/diagnosticos/diagnosticos.component';
import { DiagnosticoComponent } from './catalogos/diagnostico/diagnostico.component';
import { AntibioticosComponent } from './catalogos/antibioticos/antibioticos.component';
import { AntibioticoComponent } from './catalogos/antibiotico/antibiotico.component';
import { AdministradorEnfermerasSaldosGeneralComponent } from './administradores/administrador-enfermeras-saldos-general/administrador-enfermeras-saldos-general.component';
import { AdministradorMedicosSaldosGeneralComponent } from './administradores/administrador-medicos-saldos-general/administrador-medicos-saldos-general.component';
import { CanjeMedicoSolicitudComponent } from '../components/canje-medico-solicitud/canje-medico-solicitud.component';
import { EnfermeraCanjeDetalleComponent } from './enfermeras/enfermera-canje-detalle/enfermera-canje-detalle.component';
import { MedicoCanjeDetalleComponent } from './medicos/medico-canje-detalle/medico-canje-detalle.component';
import { AdministradorUsuarioNuevoComponent } from './administradores/administrador-usuario-nuevo/administrador-usuario-nuevo.component';
import { AdministradorUsuarioActualizarComponent } from './administradores/administrador-usuario-actualizar/administrador-usuario-actualizar.component';
import { AdministradorDistribuidorNuevoComponent } from './administradores/administrador-distribuidor-nuevo/administrador-distribuidor-nuevo.component';
import { AdministradorDistribuidoresComponent } from './administradores/administrador-distribuidores/administrador-distribuidores.component';
import { SupervisorCasoclinicoComponent } from './supervisores/supervisor-casoclinico/supervisor-casoclinico.component';
import { PuntoComponent } from './catalogos/punto/punto.component';
import { PuntosComponent } from './catalogos/puntos/puntos.component';
import { CanjeMedicoAtenderComponent } from '../components/canje-medico-atender/canje-medico-atender.component';
import { CanjeMedicoVistaComponent } from '../components/canje-medico-vista/canje-medico-vista.component';
import { AdministradorInformeCanjesMedicosComponent } from './administradores/administrador-informe-canjes-medicos/administrador-informe-canjes-medicos.component';
import { SupervisorCanjeComponent } from './supervisores/supervisor-canje/supervisor-canje.component';
import { SupervisorCanjesComponent } from './supervisores/supervisor-canjes/supervisor-canjes.component';
import { SupervisorCanjeDetalleComponent } from './supervisores/supervisor-canje-detalle/supervisor-canje-detalle.component';
import { RedimirSupervisorAtenderComponent } from '../components/redimir-supervisor-atender/redimir-supervisor-atender.component';
import { RedimirSupervisorVistaComponent } from '../components/redimir-supervisor-vista/redimir-supervisor-vista.component';


export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  const auth = inject(AuthService);
  if (auth.isLoggedIn) {
    return true;
  } else {
    return router.navigate(['']);

  }
};

const routes: Routes = [
  { path: '', component: SigninComponent },
  { path: 'recuperar-password', component: RecuperarPasswordComponent },
  {
    path: 'medico', component: MedicoComponent,
    children: [
      { path: 'casosclinicos', component: MedicoCasosclinicosComponent },
      { path: 'casoclinico/:id', component: MedicoCasoclinicoComponent },
      { path: 'productos', component: MedicoProductosComponent },
      { path: 'canjes', component: MedicoCanjesComponent },
      { path: 'solicitud/canje', component: MedicoCanjeComponent },
      { path: 'canje/detalle/:id', component: MedicoCanjeDetalleComponent },
      { path: 'saldo', component: MedicoSaldoComponent }
    ],
    canActivate: [authGuard]
  },

  {
    path: 'enfermera', component: EnfermeraComponent,
    children: [
      { path: 'casosclinicos', component: EnfermeraCasosclinicosComponent },
      { path: 'productos', component: EnfermeraProductosComponent },
      { path: 'saldo', component: EnfermeraSaldoComponent },
      { path: 'canjes', component: EnfermeraCanjesComponent },
      { path: 'solicitud/canje', component: EnfermeraCanjeComponent },
      { path: 'canje/detalle/:id', component: EnfermeraCanjeDetalleComponent }

    ],
    canActivate: [authGuard]
  },
  {
    path: 'supervisor', component: SupervisorComponent,
    children: [
      { path: 'casoclinico/:id', component: SupervisorCasoclinicoComponent },
      { path: 'casosclinicos', component: SupervisorCasosclinicosComponent },
      { path: 'enfermeras', component: SupervisorEnfermerasComponent },
      { path: 'enfermera/:id', component: SupervisorEnfermeraComponent },
      { path: 'vista/canje/:id', component: RedimirEnfermeraVistaComponent },
      { path: 'pendientes', component: SupervisorPendientesAsignarComponent },
      { path: 'canjes', component: SupervisorCanjesComponent },
      { path: 'solicitud/canje', component: SupervisorCanjeComponent },
      { path: 'canje/detalle/:id', component: SupervisorCanjeDetalleComponent },
      { path: 'hospitales', component: AdministradorHospitalesComponent },
      { path: 'hospital/nuevo', component: AdministradorHospitalNuevoComponent },
      { path: 'instituciones', component: AdministradorInstitucionesComponent },
      { path: 'institucion/nuevo', component: AdministradorInstitucionNuevoComponent },
    ],
    canActivate: [authGuard]
  },
  {
    path: 'administrador', component: AdministradorComponent,
    children: [
      { path: '', component: AdministradorInformacionInicialComponent },
      { path: 'casosclinicos', component: AdministradorCasosclinicosComponent },
      { path: 'casoclinico/:id', component: AdministradorCasoclinicoComponent },
      { path: 'casoclinico/actualizar/:id', component: AdministradorCasoclinicoUpdateComponent },
      { path: 'usuarios', component: AdministradorUsuariosComponent },
      { path: 'usuario/nuevo', component: AdministradorUsuarioNuevoComponent },
      { path: 'usuario/actualizar/:tipo/:id', component: AdministradorUsuarioActualizarComponent },
      { path: 'distribuidores', component: AdministradorDistribuidoresComponent },
      { path: 'distribuidor/nuevo', component: AdministradorDistribuidorNuevoComponent },
      { path: 'enfermeras', component: AdministradorEnfermerasComponent },
      { path: 'enfermera/:id', component: AdministradorEnfermeraComponent },
      { path: 'enfermera/atender/canje/:id', component: RedimirEnfermeraAtenderComponent },
      { path: 'enfermera/vista/canje/:id', component: RedimirEnfermeraVistaComponent },
      { path: 'productos', component: AdministradorProductosComponent },
      { path: 'producto/:id', component: AdministradorProductoComponent },
      { path: 'productos/batch', component: AdministradorProductosUploadBatchComponent },
      { path: 'medicos', component: AdministradorMedicosComponent },
      { path: 'medico/:id', component: AdministradorMedicoComponent },
      { path: 'medico/atender/canje/:id', component: CanjeMedicoAtenderComponent },
      { path: 'medico/vista/canje/:id', component: CanjeMedicoVistaComponent },
      { path: 'medico/solicitud/canje/:id', component: CanjeMedicoSolicitudComponent },
      { path: 'supervisores', component: AdministradorSupervisoresComponent },
      { path: 'supervisor/:id', component: AdministradorSupervisorComponent },
      { path: 'supervisor/atender/canje/:id', component: RedimirSupervisorAtenderComponent },
      { path: 'supervisor/vista/canje/:id', component: RedimirSupervisorVistaComponent },
      { path: 'hospitales', component: AdministradorHospitalesComponent },
      { path: 'hospital/nuevo', component: AdministradorHospitalNuevoComponent },
      { path: 'instituciones', component: AdministradorInstitucionesComponent },
      { path: 'institucion/nuevo', component: AdministradorInstitucionNuevoComponent },
      { path: 'catalogo/nuevo', component: AdministradorCatalogoComponent },
      { path: 'diagnosticos', component: DiagnosticosComponent },
      { path: 'diagnostico/nuevo', component: DiagnosticoComponent },
      { path: 'antibioticos', component: AntibioticosComponent },
      { path: 'antibiotico/nuevo', component: AntibioticoComponent },
      { path: 'saldogeneral/enfermeras', component: AdministradorEnfermerasSaldosGeneralComponent },
      { path: 'saldogeneral/medicos', component: AdministradorMedicosSaldosGeneralComponent },
      { path: 'puntos', component: PuntosComponent },
      { path: 'puntos/nuevo', component: PuntoComponent },
      { path: 'informe/canjes/medicos', component: AdministradorInformeCanjesMedicosComponent }
    ],
    canActivate: [authGuard]
  },
  { path: 'registrar/medico', component: MedicoRegistrarNuevoComponent },
  { path: 'registrar/enfermera', component: EnfermeraRegistrarNuevoComponent },
  { path: 'registrar/supervisor', component: SupervisorRegistrarNuevoComponent },
  { path: 'registrar', component: SignupComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PagesUiRoutingModule { }


/*
import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes, ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';

// ✅ IMPORT QUE TE FALTABA (ya lo tenías bien)
import { AdministradorLogsisComponent } from './administradores/administrador-logsis/administrador-logsis.component';

import { RecuperarPasswordComponent } from './logins/pass/recuperar-password.component';
import { MedicoComponent } from './medicos/medico/medico.component';
import { MedicoCasosclinicosComponent } from './medicos/medico-casosclinicos/medico-casosclinicos.component';
import { SigninComponent } from './logins/signin/signin.component';
import { SignupComponent } from './logins/signup/signup.component';
import { EnfermeraComponent } from './enfermeras/enfermera/enfermera.component';
import { SupervisorComponent } from './supervisores/supervisor/supervisor.component';
import { AdministradorComponent } from './administradores/administrador/administrador.component';
import { AdministradorCasosclinicosComponent } from './administradores/administrador-casosclinicos/administrador-casosclinicos.component';
import { AdministradorCasoclinicoUpdateComponent } from './administradores/administrador-casoclinico-update/administrador-casoclinico-update.component';
import { AdministradorEnfermerasComponent } from './administradores/administrador-enfermeras/administrador-enfermeras.component';
import { AdministradorProductosComponent } from './administradores/administrador-productos/administrador-productos.component';
import { AdministradorProductoComponent } from './administradores/administrador-producto/administrador-producto.component';
import { AdministradorMedicosComponent } from './administradores/administrador-medicos/administrador-medicos.component';
import { AdministradorSupervisoresComponent } from './administradores/administrador-supervisores/administrador-supervisores.component';
import { MedicoProductosComponent } from './medicos/medico-productos/medico-productos.component';
import { AdministradorHospitalesComponent } from './administradores/administrador-hospitales/administrador-hospitales.component';
import { AdministradorHospitalNuevoComponent } from './administradores/administrador-hospital-nuevo/administrador-hospital-nuevo.component';
import { AdministradorInstitucionesComponent } from './administradores/administrador-instituciones/administrador-instituciones.component';
import { AdministradorInstitucionNuevoComponent } from './administradores/administrador-institucion-nuevo/administrador-institucion-nuevo.component';
import { AdministradorCatalogoComponent } from './administradores/administrador-catalogo/administrador-catalogo.component';
import { AdministradorUsuariosComponent } from './administradores/administrador-usuarios/administrador-usuarios.component';
import { MedicoRegistrarNuevoComponent } from './medicos/medico-registrar-nuevo/medico-registrar-nuevo.component';
import { EnfermeraRegistrarNuevoComponent } from './enfermeras/enfermera-registrar-nuevo/enfermera-registrar-nuevo.component';
import { SupervisorRegistrarNuevoComponent } from './supervisores/supervisor-registrar-nuevo/supervisor-registrar-nuevo.component';
import { AdministradorCasoclinicoComponent } from './administradores/administrador-casoclinico/administrador-casoclinico.component';
import { AdministradorMedicoComponent } from './administradores/administrador-medico/administrador-medico.component';
import { AdministradorInformacionInicialComponent } from './administradores/administrador-informacion-inicial/administrador-informacion-inicial.component';
import { AdministradorEnfermeraComponent } from './administradores/administrador-enfermera/administrador-enfermera.component';
import { AdministradorSupervisorComponent } from './administradores/administrador-supervisor/administrador-supervisor.component';
import { MedicoCasoclinicoComponent } from './medicos/medico-casoclinico/medico-casoclinico.component';
import { AuthService } from 'src/app/services/auth.service';
import { MedicoSaldoComponent } from './medicos/medico-saldo/medico-saldo.component';
import { MedicoCanjesComponent } from './medicos/medico-canjes/medico-canjes.component';
import { MedicoCanjeComponent } from './medicos/medico-canje/medico-canje.component';
import { EnfermeraCasosclinicosComponent } from './enfermeras/enfermera-casosclinicos/enfermera-casosclinicos.component';
import { EnfermeraProductosComponent } from './enfermeras/enfermera-productos/enfermera-productos.component';
import { EnfermeraSaldoComponent } from './enfermeras/enfermera-saldo/enfermera-saldo.component';
import { EnfermeraCanjesComponent } from './enfermeras/enfermera-canjes/enfermera-canjes.component';
import { EnfermeraCanjeComponent } from './enfermeras/enfermera-canje/enfermera-canje.component';
import { SupervisorCasosclinicosComponent } from './supervisores/supervisor-casosclinicos/supervisor-casosclinicos.component';
import { SupervisorEnfermerasComponent } from './supervisores/supervisor-enfermeras/supervisor-enfermeras.component';
import { SupervisorPendientesAsignarComponent } from './supervisores/supervisor-pendientes-asignar/supervisor-pendientes-asignar.component';
import { RedimirEnfermeraAtenderComponent } from '../components/redimir-enfermera-atender/redimir-enfermera-atender.component';
import { RedimirMedicoAtenderComponent } from '../components/redimir-medico-atender/redimir-medico-atender.component';
import { RedimirMedicoVistaComponent } from '../components/redimir-medico-vista/redimir-medico-vista.component';
import { RedimirEnfermeraVistaComponent } from '../components/redimir-enfermera-vista/redimir-enfermera-vista.component';
import { AdministradorProductosUploadBatchComponent } from './administradores/administrador-productos-upload-batch/administrador-productos-upload-batch.component';
import { SupervisorEnfermeraComponent } from './supervisores/supervisor-enfermera/supervisor-enfermera.component';
import { DiagnosticosComponent } from './catalogos/diagnosticos/diagnosticos.component';
import { DiagnosticoComponent } from './catalogos/diagnostico/diagnostico.component';
import { AntibioticosComponent } from './catalogos/antibioticos/antibioticos.component';
import { AntibioticoComponent } from './catalogos/antibiotico/antibiotico.component';
import { AdministradorEnfermerasSaldosGeneralComponent } from './administradores/administrador-enfermeras-saldos-general/administrador-enfermeras-saldos-general.component';
import { AdministradorMedicosSaldosGeneralComponent } from './administradores/administrador-medicos-saldos-general/administrador-medicos-saldos-general.component';
import { CanjeMedicoSolicitudComponent } from '../components/canje-medico-solicitud/canje-medico-solicitud.component';
import { EnfermeraCanjeDetalleComponent } from './enfermeras/enfermera-canje-detalle/enfermera-canje-detalle.component';
import { MedicoCanjeDetalleComponent } from './medicos/medico-canje-detalle/medico-canje-detalle.component';
import { AdministradorUsuarioNuevoComponent } from './administradores/administrador-usuario-nuevo/administrador-usuario-nuevo.component';
import { AdministradorDistribuidorNuevoComponent } from './administradores/administrador-distribuidor-nuevo/administrador-distribuidor-nuevo.component';
import { AdministradorDistribuidoresComponent } from './administradores/administrador-distribuidores/administrador-distribuidores.component';
import { SupervisorCasoclinicoComponent } from './supervisores/supervisor-casoclinico/supervisor-casoclinico.component';
import { PuntoComponent } from './catalogos/punto/punto.component';
import { PuntosComponent } from './catalogos/puntos/puntos.component';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return auth.isLoggedIn ? true : router.navigate(['']);
};

const routes: Routes = [
  { path: '', component: SigninComponent },
  { path: 'recuperar-password', component: RecuperarPasswordComponent },

  {
    path: 'administrador',
    component: AdministradorComponent,
    children: [
      { path: '', component: AdministradorInformacionInicialComponent },

      // ✅ ESTA ES LA SOLUCIÓN
      { path: 'logsis', component: AdministradorLogsisComponent },

      { path: 'casosclinicos', component: AdministradorCasosclinicosComponent },
      { path: 'casoclinico/:id', component: AdministradorCasoclinicoComponent },

      { path: 'productos', component: AdministradorProductosComponent },
      { path: 'productos/batch', component: AdministradorProductosUploadBatchComponent },

      { path: 'medicos', component: AdministradorMedicosComponent },
      { path: 'supervisores', component: AdministradorSupervisoresComponent },

      { path: 'usuarios', component: AdministradorUsuariosComponent },

      { path: 'diagnosticos', component: DiagnosticosComponent },
      { path: 'antibioticos', component: AntibioticosComponent }
    ],
    canActivate: [authGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesUiRoutingModule { }
*/